export { default as ConfirmationModalStyle } from "@/styles/components/common-modal/confirmation-modal/_index.module.scss";
export { default as InfoModalStyle } from "@/styles/components/common-modal/info-modal/_index.module.scss";
export { default as FormModalStyle } from "@/styles/components/common-modal/form-modal/_index.module.scss";
export { default as Button } from "@/components/button";
export { default as ConfirmationModal } from "@/components/common-modal/confirmationModal/confirmationModal";
export { default as Image } from "next/image";
export { default as InfoModal } from "@/components/common-modal/infoModal/infoModal";
export { default as Close } from 'public/new-icons/close.svg';
export { default as ClosePill } from 'public/new-icons/pill-close.svg';
